import InlineBlot from 'quill/blots/inline';
/**
 * Permit to use INSERTS tag in template-mail edition
 * */
class InsertsBlot extends InlineBlot {
  static create(): HTMLElement {
    const insertsHtmlElement = super.create();
    insertsHtmlElement.setAttribute('contenteditable', 'false');
    return insertsHtmlElement;
  }
  static formats(): boolean {
    return true;
  }
}

InsertsBlot.blotName = 'inserts';
InsertsBlot.tagName = 'inserts';
export default InsertsBlot;
